import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=f9b953f4&scoped=true"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"
import style0 from "./teamList.vue?vue&type=style&index=0&id=f9b953f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b953f4",
  null
  
)

export default component.exports